if (!customElements.get('fairfax-product-form')) {
  customElements.define('fairfax-product-form', class FairfaxProductForm extends BaseElement {
    constructor ()
    {
      super();

      this.initEvents();
    }

    init ()
    {
      this.initMobile();
      this.addVariantPrices();
      this.initVariantSelection();
      this.initViews();
      this.initBuyOptions();
      this.initBuyButton();
      this.updateVariants();
      this.updateErrors();
    }

    initViews ()
    {
      const variantButton = this.querySelector('.product-form-view-main .product-form-selected-variant-body');
      const variantsBack = this.querySelector('.product-form-view-variants-back');

      if (variantButton) {
        variantButton.addEventListener('click', e => {
          e.preventDefault();
          this.showView('variants');
        });
      }

      if (variantsBack) {
        variantsBack.addEventListener('click', e => {
          e.preventDefault();
          this.showView('main');
        });
      }
    }

    showView (name)
    {
      this.querySelectorAll('.product-form-view').forEach(view => view.style.display = 'none');
      const target = this.querySelector('.product-form-view-' + name);
      if (target) target.style.display = 'block';
    }

    handleAutoChoose (item)
    {
      if (item.querySelector('input').disabled) return;

      if (this._autoChooseTimeout) {
        clearTimeout(this._autoChooseTimeout);
      }

      item.classList.add('is-auto-choosing');

      this._autoChooseTimeout = setTimeout(() => {
        item.classList.remove('is-auto-choosing');
        this.showView('main');
      }, 400);
    }

    initEvents ()
    {
      this.initErrors();

      this.onBroadcast('treatment_country', async data => {
        await this.checkQuotaExceeded(data);
        this.updateVariants();
        this.updateErrors();
      });

      // Re-run the buy gate when the AU state changes so the state requirement
      // clears once a state is chosen.
      this.onBroadcast('treatment_au_state_change', () => {
        this.updateVariants();
        this.updateErrors();
      });

      this.onBroadcast('variant_change', () => {
        this.querySelectorAll('.product-form-buy-option-quantity input').forEach(input => input.value = 0);
        this.updateErrors();
      });
    }

    initMobile ()
    {
      const mobile = document.querySelector('.product-form-mobile');

      if (!mobile) {
        return;
      }

      mobile.querySelector('.product-form-mobile-buy-button').addEventListener('click', e => {
        e.preventDefault();

        document.body.classList.toggle('show-product-form');
      });

      document.body.appendChild(mobile);

      const closeBtn = this.querySelector('.product-form-close');

      if (closeBtn) {
        closeBtn.addEventListener('click', e => {
          e.preventDefault();

          document.body.classList.remove('show-product-form');
        });
      }

      this.querySelectorAll('.product-form-buy-button').forEach(btn => {
        btn.addEventListener('click', () => {
          document.body.classList.remove('show-product-form');
        });
      });

      const rightCol = document.querySelector('.fairfax-page-right')
        || document.querySelector('.product-page-right');

      if (rightCol) {
        rightCol.addEventListener('click', e => {
          if (e.customStopPropagation !== 'popup') {
            document.body.classList.remove('show-product-form');
          }
        });

        rightCol.querySelectorAll(':scope > section').forEach(section => {
          section.addEventListener('click', e => {
            e.customStopPropagation = 'popup';
          });
        });
      }
    }

    initVariantSelection ()
    {
      this.querySelectorAll('.product-form-variants-item').forEach(item => {
        const input = item.querySelector('input');

        input.addEventListener('change', () => {
          this.updateVariants();
          this.updateErrors();
          this.handleAutoChoose(item);
        });
      });
    }

    addVariantPrices ()
    {
      this.querySelectorAll('.product-form-variants-item').forEach(item => {
        const variantId = item.dataset.variantId;
        const variant = this.getVariant(variantId);

        if (!variant) {
          return;
        }

        item.querySelector('.product-form-variants-item-price').innerHTML = window.app.money(variant.price / 100);
      });
    }

    updateVariants ()
    {
      let selected = null;

      this.querySelectorAll('.product-form-variants-item').forEach(item => {
        const input = item.querySelector('input');

        if (input.checked) {
          selected = item;
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });

      const idInput = this.querySelector('form input[name="id"]');

      if (selected) {
        if (idInput) {
          idInput.value = selected.dataset.variantId;
        }

        this.querySelectorAll('.product-form-selected-variant').forEach(container => {
          container.classList.add('has-value');
          const valueEl = container.querySelector('.product-form-selected-variant-value .value');
          const priceEl = container.querySelector('.product-form-selected-variant-price');
          const nameEl = selected.querySelector('.product-form-variants-item-name');
          const itemPriceEl = selected.querySelector('.product-form-variants-item-price');
          if (valueEl && nameEl) valueEl.innerHTML = nameEl.innerHTML;
          if (priceEl && itemPriceEl) priceEl.innerHTML = itemPriceEl.innerHTML;
        });

        this.querySelectorAll('.product-form-buy-options').forEach(buyOptions => {
          if (typeof selected.dataset.variantQuantity === 'string') {
            // Whole sets only for set-rule treatment countries (e.g. AU):
            // 9 in stock → a max of 6.
            const setSize = this.strawSetSize();
            const max = parseInt(selected.dataset.variantQuantity);

            buyOptions.dataset.maxQuantity = (setSize > 1 && !Number.isNaN(max))
              ? max - (max % setSize)
              : selected.dataset.variantQuantity;
          } else {
            delete buyOptions.dataset.maxQuantity;
          }
        });
      } else {
        this.querySelectorAll('.product-form-selected-variant').forEach(container => {
          container.classList.remove('has-value');
        });
        this.querySelectorAll('.product-form-buy-options').forEach(buyOptions => {
          delete buyOptions.dataset.maxQuantity;
        });
      }

      this.updateStrawSetNotice();
    }

    strawSetSize ()
    {
      return window.app && window.app.strawSets
        ? window.app.strawSets.sizeForSelection()
        : 1;
    }

    // Fewer straws in stock than one whole set — nothing purchasable for a
    // set-rule country even though the variant is natively available.
    isBelowOneSet (variantId)
    {
      const setSize = this.strawSetSize();

      if (setSize <= 1) {
        return false;
      }

      const item = this.querySelector(`.product-form-variants-item[data-variant-id="${variantId}"]`);

      if (!item || typeof item.dataset.variantQuantity !== 'string') {
        return false;
      }

      const max = parseInt(item.dataset.variantQuantity);

      return !Number.isNaN(max) && max < setSize;
    }

    hasStrawSetMisalignment ()
    {
      const step = this.strawSetSize();

      if (step <= 1) {
        return false;
      }

      let misaligned = false;

      this.querySelectorAll('.product-form-buy-option input[name="quantity"]').forEach(input => {
        const value = parseInt(input.value);

        if (!Number.isNaN(value) && value % step !== 0) {
          misaligned = true;
        }
      });

      return misaligned;
    }

    strawSetQuantityError ()
    {
      return ((window.ProductString && ProductString.StrawSetQuantity) || 'Straws are sold in sets of [quantity].')
        .replace('[quantity]', this.strawSetSize());
    }

    updateStrawSetNotice ()
    {
      const setSize = this.strawSetSize();

      this.querySelectorAll('[data-straw-set-notice]').forEach(notice => {
        if (setSize > 1) {
          notice.textContent = (notice.dataset.strawSetNoticeTemplate || '').replace('[quantity]', setSize);
          notice.classList.remove('hidden');
        } else {
          notice.classList.add('hidden');
        }
      });
    }

    initBuyOptions ()
    {
      this.optionsError = this.querySelector('.product-add-options-error');

      this.querySelectorAll('.product-form-buy-option').forEach(option => {
        const input = option.querySelector('input');
        const minus = option.querySelector('.product-form-buy-option-quantity-minus');
        const plus = option.querySelector('.product-form-buy-option-quantity-plus');

        input.addEventListener('keydown', e => {
          const charCode = (typeof e.which == 'undefined') ? e.keyCode : e.which;
          const charStr = String.fromCharCode(charCode);

          if (!/^\d*\.?\d*$/.test(charStr)) {
            e.preventDefault();

            return false;
          }
        });

        input.addEventListener('keyup', () => {
          const max = option.closest('.product-form-buy-options').dataset.maxQuantity;
          let current = Number.isNaN(parseInt(input.value)) ? 0 : parseInt(input.value);

          if (max && current > parseInt(max)) {
            current = parseInt(max);
            input.value = current;
          }

          this.updateErrors();
        });

        // Hand-typed quantities snap down to a whole set on blur.
        input.addEventListener('change', e => {
          const step = this.strawSetSize();

          if (step <= 1) {
            return;
          }

          const current = parseInt(input.value);

          if (!Number.isNaN(current) && current % step !== 0) {
            input.value = current - (current % step);

            this.updateErrors();
          }
        });

        minus.addEventListener('click', e => {
          e.preventDefault();

          if (option.classList.contains('disabled')) {
            return;
          }

          const step = this.strawSetSize();
          let current = Number.isNaN(parseInt(input.value)) ? 1 : parseInt(input.value);

          // Down to the next-lower multiple of the set size (plain -1 when no
          // set rule applies), never below 0.
          current = (Math.ceil(current / step) - 1) * step;

          if (current < 0) {
            current = 0;
          }

          input.value = current;

          this.updateErrors();
        });

        plus.addEventListener('click', e => {
          e.preventDefault();

          if (option.classList.contains('disabled')) {
            return;
          }

          const step = this.strawSetSize();
          let current = Number.isNaN(parseInt(input.value)) ? 0 : parseInt(input.value);

          // Up to the next multiple of the set size (plain +1 when no set
          // rule applies).
          current = (Math.floor(current / step) + 1) * step;

          const max = option.closest('.product-form-buy-options').dataset.maxQuantity;

          if (max && current > parseInt(max)) {
            current = parseInt(max);

            // Keep the clamped value on a set boundary (the max itself is
            // already rounded down in updateVariants, so this is a no-op
            // there — it guards stale attribute values).
            current = current - (current % step);
          }

          input.value = current;

          this.updateErrors();
        });
      });
    }

    initBuyButton ()
    {
      this.querySelectorAll('.product-form-buy-button').forEach(button => {
        button.addEventListener('click', e => {
          e.preventDefault();

          document.body.classList.remove('show-product-form');

          if (button.classList.contains('disabled')) {
            return;
          }

          this.onSubmit();
        });
      });
    }

    initErrors ()
    {
      this.querySelectorAll('.product-form-buy-button, .product-form-buy-option').forEach(div => {
        div.dataset.originalDisabled = div.classList.contains('disabled') ? 'disabled' : '';
      });
    }

    getVariants ()
    {
      return JSON.parse(this.querySelector('#variants-json').textContent);
    }

    getVariant (id)
    {
      return this.getVariants().find(variant => variant.id == id);
    }

    getCurrentVariant ()
    {
      let result = null;

      this.querySelectorAll('.product-form-variants-item').forEach(item => {
        if (item.querySelector('input').checked) {
          result = this.getVariant(item.dataset.variantId);
        }
      });

      return result;
    }

    getPregnancyQuotaInput ()
    {
      if (!window.app || !window.app.pregnancyQuotas) {
        return null;
      }

      const pregnancyQuotaVariant = window.app.pregnancyQuotas.getPregnancyQuotaVariant(undefined, undefined, window.productData.globalFamilyLimit);

      if (!pregnancyQuotaVariant) {
        return null;
      }

      const container = this.querySelector('[data-pregnancy-quota-country="' + pregnancyQuotaVariant.country + '"]');

      if (!container) {
        return null;
      }

      return container.querySelector('[name="properties[__pregnancy_quota]"]');
    }

    isSoldOut (variantId)
    {
      const variant = this.getVariant(variantId);

      return !variant || !variant.available;
    }

    isSoldOutAll ()
    {
      let soldOut = true;

      this.querySelectorAll('.product-form-variants-item').forEach(item => {
        if (!item.classList.contains('product-form-variants-item-sold-out')) {
          soldOut = false;
        }
      });

      return soldOut;
    }

    isQuotaExceeded ()
    {
      const pqInput = this.getPregnancyQuotaInput();

      if (!pqInput || !pqInput.checked) {
        return false;
      }

      const quotaDiv = this.querySelector('.product-form-quota');

      return !!quotaDiv && quotaDiv.classList.contains('show');
    }

    isTreatmentAvailable ()
    {
      const selection = window.app && window.app.treatmentCountry
        ? window.app.treatmentCountry.getSelection()
        : { country: null, state: null };

      if (!selection.country) {
        return false;
      }

      if (this.customerHasQuota) {
        return true;
      }

      const countryEl = document.querySelector('#product-treatment-country');

      if (!countryEl || !countryEl.dataset.countries) {
        return true;
      }

      const countries = JSON.parse(countryEl.dataset.countries);
      const code = selection.country.toLowerCase();

      return typeof countries[code] !== 'undefined' && countries[code].available;
    }

    updateErrors ()
    {
      const currentVariant = this.getCurrentVariant();
      const buyOptions = this.querySelectorAll('.product-form-buy-option');

      this.querySelectorAll('.product-form-buy-button').forEach(buyButton => {
        let buyDisabled = false;
        let quantityDisabled = false;
        let buyDisabledReason = null;

        if (!window.app || !window.app.customer || !window.app.customer.residentialCountry) {
          buyButton.classList.add('disabled', 'disabled-residential');
          buyButton.dataset.tippyTitle = ProductString.SelectResidentialCountry;
          buyDisabledReason = ProductString.SelectResidentialCountry;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          buyButton.classList.remove('disabled-residential');
        }

        // Australia requires a state/territory before purchase (mirrors the
        // backend AU enforcement; clinic/stock/quota all key off it).
        const treatmentSelection = window.app && window.app.treatmentCountry
          ? window.app.treatmentCountry.getSelection()
          : { country: null, state: null };

        if (!buyDisabled && treatmentSelection.country === 'AU' && !treatmentSelection.state) {
          buyButton.classList.add('disabled', 'disabled-treatment-state');
          buyButton.dataset.tippyTitle = ProductString.SelectTreatmentState;
          buyDisabledReason = ProductString.SelectTreatmentState;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          buyButton.classList.remove('disabled-treatment-state');
        }

        const treatmentUnavailableEl = document.querySelector('.product-treatment-error-unavailable');

        if (!buyDisabled && !this.isTreatmentAvailable()) {
          if (treatmentUnavailableEl) treatmentUnavailableEl.classList.remove('hidden');
          buyButton.classList.add('disabled', 'disabled-treatment');
          buyButton.dataset.tippyTitle = ProductString.TreatmentUnavailable;
          buyDisabledReason = ProductString.TreatmentUnavailable;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          if (treatmentUnavailableEl) treatmentUnavailableEl.classList.add('hidden');
          buyButton.classList.remove('disabled-treatment');
        }

        if (!buyDisabled && this.isQuotaExceeded()) {
          buyButton.classList.add('disabled', 'disabled-quota');
          buyButton.dataset.tippyTitle = ProductString.QuotaExceeded;
          buyDisabledReason = ProductString.QuotaExceeded;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          buyButton.classList.remove('disabled-quota');
        }

        if (
          (!buyDisabled && currentVariant && this.isSoldOut(currentVariant.id))
          || (!buyDisabled && currentVariant && this.isBelowOneSet(currentVariant.id))
          || this.isSoldOutAll()
        ) {
          buyButton.classList.add('disabled', 'disabled-sold-out');
          buyButton.textContent = ProductString.SoldOut;
          buyButton.dataset.tippyTitle = ProductString.SoldOut;
          buyDisabledReason = ProductString.SoldOut;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          buyButton.textContent = buyButton.dataset.addToCartText;
          buyButton.classList.remove('disabled-sold-out');
        }

        if (!buyDisabled && !currentVariant) {
          buyButton.classList.add('disabled', 'disabled-variant');
          buyButton.dataset.tippyTitle = ProductString.SelectVariant;
          buyDisabledReason = ProductString.SelectVariant;
          buyDisabled = true;
          quantityDisabled = true;
        } else {
          buyButton.classList.remove('disabled-variant');
        }

        if (!buyDisabled) {
          let totalQuantity = 0;

          this.querySelectorAll('.product-form-buy-option input[name="quantity"]').forEach(input => {
            totalQuantity += Number.isNaN(parseInt(input.value)) ? 0 : parseInt(input.value);
          });

          if (totalQuantity === 0) {
            buyButton.classList.add('disabled', 'disabled-quantity');
            buyButton.dataset.tippyTitle = ProductString.VariantQuantity;
            buyDisabledReason = ProductString.VariantQuantity;
            buyDisabled = true;
            quantityDisabled = false;
          } else if (this.hasStrawSetMisalignment()) {
            // A quantity that isn't a whole set (only reachable by typing).
            const strawSetError = this.strawSetQuantityError();

            buyButton.classList.add('disabled', 'disabled-quantity');
            buyButton.dataset.tippyTitle = strawSetError;
            buyDisabledReason = strawSetError;
            buyDisabled = true;
            quantityDisabled = false;
          } else {
            buyButton.classList.remove('disabled-quantity');
            buyButton.textContent = buyButton.dataset.addToCartText;
          }
        }

        // Destroy before initTippy() can re-init — it overwrites
        // .tippyInstance without destroying, leaving the old tooltip alive
        // on the element (stacked/overlapping tooltips).
        const destroyQuantityTooltip = (quantity) => {
          quantity.classList.remove('tippy-initialized');

          if (quantity.tippyInstance) {
            quantity.tippyInstance.destroy();
            quantity.tippyInstance = null;
          }
        };

        const unlockQuantity = () => {
          buyOptions.forEach(buyOption => {
            const quantity = buyOption.querySelector('.product-form-buy-option-quantity');

            buyOption.classList.remove('disabled');
            buyOption.querySelector('input').disabled = false;
            destroyQuantityTooltip(quantity);
            delete quantity.dataset.tippyTitle;
          });
        };

        buyButton.classList.remove('tippy-initialized');

        if (buyButton.tippyInstance) {
          buyButton.tippyInstance.destroy();
          buyButton.tippyInstance = null;
        }

        if (!buyDisabled) {
          if (buyButton.dataset.originalDisabled === 'disabled') {
            buyButton.classList.add('disabled');
          } else {
            buyButton.classList.remove('disabled');
          }

          delete buyButton.dataset.tippyTitle;

          unlockQuantity();
        } else if (quantityDisabled) {
          buyOptions.forEach(buyOption => {
            const quantity = buyOption.querySelector('.product-form-buy-option-quantity');

            buyOption.classList.add('disabled');
            buyOption.querySelector('input').disabled = true;
            destroyQuantityTooltip(quantity);

            if (buyDisabledReason) {
              quantity.dataset.tippyTitle = buyDisabledReason;
            } else {
              delete quantity.dataset.tippyTitle;
            }
          });
        } else {
          unlockQuantity();
        }
      });

      if (window.app && typeof window.app.initTippy === 'function') {
        window.app.initTippy();
      }
    }

    async checkQuotaExceeded (data)
    {
      const quotaExceededDiv = this.querySelector('.product-form-quota');

      if (!quotaExceededDiv) {
        return;
      }

      this.querySelectorAll('.product-form-addons-quotas .product-form-addons-item').forEach(quota => quota.classList.add('hidden'));

      const pqInput = this.getPregnancyQuotaInput();

      if (pqInput) {
        pqInput.closest('.product-form-addons-quotas .product-form-addons-item').classList.remove('hidden');
      }

      if (!window.app.customer.residentialCountry) {
        return;
      }

      const donor = window.productData.title;

      try {
        const response = await fetch(
          'https://app.donornetwork.com/api/shopify/customer/quota-available'
            + '?treatment_country=' + data.code
            + '&residence_country=' + window.app.customer.residentialCountry.toUpperCase()
            + '&donor=' + donor
            + window.app.treatmentCountry.stateQueryParam(),
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              ...window.app.apiHeaders(),
            },
          }
        );

        const dataResponse = await response.json();
        window.app.pregnancyQuotas.rememberQuotaVariantCountry(data.code, window.app.customer.residentialCountry, dataResponse.data.quota_variant_country);
        const hasQuota = dataResponse.data.customer_has_quota;
        this.customerHasQuota = hasQuota;

        if (pqInput) {
          pqInput.checked = !hasQuota;
        }

        const quotaErrorEl = document.querySelector('.product-treatment-error-quota-exceeded');

        if (dataResponse.data.quota_available || hasQuota) {
          quotaExceededDiv.classList.remove('show');
          if (quotaErrorEl) quotaErrorEl.classList.add('hidden');
        } else {
          quotaExceededDiv.classList.add('show');
          if (quotaErrorEl) quotaErrorEl.classList.remove('hidden');
        }

        if (window.app && typeof window.app.initTippy === 'function') {
          window.app.initTippy();
        }
      } catch (err) {
        console.error('Fairfax quota check failed:', err);
      }
    }

    async onSubmit ()
    {
      const treatmentCountry = window.app.treatmentCountry.getSelection().country;
      const residentialCountry = window.app.customer.residentialCountry;

      if (treatmentCountry && residentialCountry) {
        try {
          const donor = window.productData.title;
          const response = await fetch(
            'https://app.donornetwork.com/api/shopify/customer/quota-available'
              + '?treatment_country=' + treatmentCountry.toUpperCase()
              + '&residence_country=' + residentialCountry.toUpperCase()
              + '&donor=' + donor
              + window.app.treatmentCountry.stateQueryParam(),
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                ...window.app.apiHeaders(),
              },
            }
          );
          const quotaData = await response.json();
          window.app.pregnancyQuotas.rememberQuotaVariantCountry(treatmentCountry, residentialCountry, quotaData.data.quota_variant_country);

          if (!quotaData.data.quota_available && !quotaData.data.customer_has_quota) {
            await this.checkQuotaExceeded({ code: treatmentCountry });
            this.updateErrors();

            return;
          }
        } catch (err) {
          console.error('Quota availability check failed:', err);
        }
      }

      const config = fetchConfig('javascript');
      const formData = new FormData(this.querySelector('form'));
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      if (cart) {
        cart.setActiveElement(document.activeElement);
      }

      const quantity = parseInt(formData.get('quantity')) || 0;

      if (quantity === 0) {
        return;
      }

      // Hard guard: never send a non-whole-set straw quantity for a set-rule
      // country (steppers and updateErrors make this unreachable via the UI).
      const setSize = this.strawSetSize();

      if (setSize > 1 && quantity % setSize !== 0) {
        if (this.optionsError) {
          this.optionsError.textContent = this.strawSetQuantityError();
          this.optionsError.classList.add('show');
        }

        return;
      }

      const pqInput = this.getPregnancyQuotaInput();
      const isPregnancyQuotaChecked = pqInput ? pqInput.checked : false;
      const localId = Date.now().toString(36) + Math.random().toString(36).substring(2);

      const mainItem = {
        id: formData.get('id'),
        quantity: quantity,
        properties: {
          __item_local_id: localId,
          __treatment: treatmentCountry,
          __shipping: 'clinic',
        }
      };

      if (pqInput) {
        mainItem.properties.__pregnancy_quota = pqInput.value;
      }

      if (formData.get('properties[__genetic_matching]')) {
        mainItem.properties.__genetic_matching = formData.get('properties[__genetic_matching]');
      }

      config.body = JSON.stringify({ items: [mainItem] });

      const submit = () => {
        fetch(window.Shopify.routes.root + 'cart/add.js?' + window.app.getQueryParamsForCartNotificationSectionsRender(), config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              this.optionsError.textContent = response.description;
              this.optionsError.classList.add('show');

              return;
            } else if (!cart) {
              window.location = window.routes.cart_url;

              return;
            }

            const mainResultItem = response.items.find(item => item.properties && item.properties.__item_local_id === localId);

            if (!mainResultItem) {
              return;
            }

            mainResultItem.sections = response.sections;
            cart.renderContents(mainResultItem);

            const addons = [];

            if (formData.get('properties[__genetic_matching]') && mainResultItem.properties.__genetic_matching) {
              addons.push({
                id: mainResultItem.properties.__genetic_matching.split(':')[1],
                quantity: 1,
                properties: {
                  __variant_id: mainResultItem.id,
                  __line_item_id: mainResultItem.id,
                  __line_item_local_id: mainResultItem.properties.__item_local_id,
                  'For': mainResultItem.product_title,
                }
              });
            }

            const addAddons = () => {
              if (addons.length === 0) {
                return;
              }

              const addonsConfig = fetchConfig('javascript');
              addonsConfig.body = JSON.stringify({ items: addons });

              fetch(window.Shopify.routes.root + 'cart/add.js', addonsConfig)
                .then(r => r.json())
                .then(() => {});
            };

            if (isPregnancyQuotaChecked && mainResultItem.properties.__pregnancy_quota) {
              fetch(window.Shopify.routes.root + 'cart.json', fetchConfig('javascript'))
                .then(r => r.json())
                .then(cartResponse => {
                  let quotaItem = false;

                  if (cartResponse.items && cartResponse.items.length > 0) {
                    cartResponse.items.forEach(lineItem => {
                      if (lineItem.product_type == 'PregnancyQuota') {
                        let productId = null;

                        cartResponse.items.forEach(lineItem2 => {
                          if (lineItem2.product_type == 'Donor'
                            && lineItem.properties.__line_item_local_id == lineItem2.properties.__item_local_id
                          ) {
                            productId = lineItem2.product_id;
                          }
                        });

                        if (productId && productId == formData.get('product_id')) {
                          quotaItem = lineItem;
                        }
                      }
                    });
                  }

                  if (!quotaItem) {
                    const quotaAddon = {
                      id: mainResultItem.properties.__pregnancy_quota.split(':')[1],
                      quantity: 1,
                      properties: {
                        __variant_id: mainResultItem.id,
                        __line_item_id: mainResultItem.id,
                        __line_item_key: mainResultItem.key,
                        __line_item_local_id: mainResultItem.properties.__item_local_id,
                        'For': mainResultItem.product_title,
                      }
                    };

                    addons.push(quotaAddon);

                    // An exclusive-tier quota brings its nonrefundable fee in
                    // the same request as the quota.
                    const feeAddon = window.app.pregnancyQuotas.exclusivityFeeLine(quotaAddon.id, quotaAddon.properties);

                    if (feeAddon) {
                      addons.push(feeAddon);
                    }
                  }

                  addAddons();
                });
            } else {
              addAddons();
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            if (cart && cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
          });
      };

      if (!window.app.getCookie('cart')
        && window.app.getCookie('cart_currency')
        && window.app.getCookie('localization')
        && !window.location.hostname.includes('127.0.0.1')
      ) {
        console.log('This session has no cart cookie, forcing one..');

        const localizationData = new URLSearchParams();
        localizationData.append('form_type', 'localization');
        localizationData.append('utf8', '✓');
        localizationData.append('_method', 'put');
        localizationData.append('country_code', window.app.getCookie('localization'));
        localizationData.append('return_to', window.location.href);

        fetch('/localization', {
          method: 'post',
          body: localizationData,
        }).then(() => {
          submit();
        });
      } else {
        submit();
      }
    }
  });
}
